<template>

  <el-container class="container">
    <el-header class="header">
      <span class="left el-icon-arrow-left" @click="returnOn"></span>
      库存盘点
    </el-header>

    <el-container style="height: calc(100vh - 110px);">
      <el-container class="container1 left-container">
        <el-main class="main left-main">
          <div class="main-title">
            基本信息
          </div>
          <div class="body">
            <div class="cell" @click="outboundDialogShow=true">
              <div class="left">盘点仓库</div>
              <div class="right">{{outboundName?outboundName:'选择仓库名称'}}<span class="el-icon-arrow-right"></span></div>
            </div>
            <div class="cell">
              <div class="left">盘点类型</div>
              <div class="right">
                <div :class="outboundType===0?'item item1':'item'" @click="outboundType=0">日盘</div>
                <div :class="outboundType===1?'item item1':'item'" @click="outboundType=1">周盘</div>
                <div :class="outboundType===2?'item item1':'item'" @click="outboundType=2">月盘</div>
              </div>
            </div>
            <div class="cell">
              <div class="left">单据日期</div>
              <div class="right">{{timePicker}}</div>
            </div>
            <div class="mark">
              <div class="mark-title">
                备注说明
              </div>
              <div class="mark-ipt">
                <el-input type="textarea" v-model="markInput" :rows="3" resize="none" placeholder="输入备注说明"
                  maxlength="300" show-word-limit>
                </el-input>
              </div>
            </div>
          </div>
        </el-main>
      </el-container>
      <el-container class="container1 right-container">
        <el-header>
          <div class="main-title">
            商品信息
            <div class="title-right">
              <div class="btn btn1" @click="clearGoods">清空已选</div>
              <div class="btn btn2" @click="goodsDrawerShow=true">添加商品</div>
            </div>
          </div>
        </el-header>
        <el-main class="main right-main">
          <div class="body">
            <div class="card" v-for="(item,i) in 20" :key='i'>
              <div class="card-title">
                <div class="name-close">
                  <div class="name">菲灵魔法定型发胶</div>
                  <div class="close el-icon-circle-close"></div>
                </div>
                <div class="size">500ml</div>
              </div>
            </div>
          </div>
        </el-main>
      </el-container>
    </el-container>
    <el-footer>
      <el-button type="primary" round @click="jumpTakingQuery">
        生成盘点清单
      </el-button>
    </el-footer>

    <!-- 仓库 -->
    <el-dialog :visible.sync="outboundDialogShow" :show-close="false" :before-close="handleClose">
      <template slot="title">
        <div class="dialog-title">
          <span></span><span class="center">选择仓库</span><span class="el-icon-close"
            @click="outboundDialogShow=false"></span>
        </div>
      </template>
      <el-container style="height:420px;">
        <el-header class="dialog-header">
          <div class="search">
            <el-input placeholder="请输入仓库名称" clearable prefix-icon="el-icon-search" v-model="outboundSearchVal">
            </el-input>
            <el-button type="primary">搜索</el-button>
          </div>
        </el-header>
        <el-main class="cell-list">
          <el-radio-group v-model="outboundRadio">
            <el-radio :label="'仓库名称'+item" v-for="(item,i) in 20" :key="i">
              <div class="dialog-title">
                仓库名称{{item}}
              </div>
            </el-radio>
          </el-radio-group>
        </el-main>
        <el-footer>
          <div class="footer">
            <div class="btn" @click="outboundConfirm">确定</div>
          </div>
        </el-footer>
      </el-container>
    </el-dialog>
    <!-- 商品 -->
    <el-drawer :visible.sync="goodsDrawerShow" :show-close="false" direction="rtl" :before-close="handleClose">
      <template slot="title">
        <div class="drawer-title">
          <span></span><span class="center">添加商品</span>
          <span class="el-icon-close" @click="goodsDrawerShow=false"></span>
        </div>
      </template>
      <el-container style="height:calc(100vh - 52px);">
        <el-header>
          <el-select v-model="region" multiple placeholder="请选择分类">
            <el-option label="润肤系列" value="润肤系列"></el-option>
            <el-option label="清洁系列" value="清洁系列"></el-option>
            <el-option label="美发系列" value="美发系列"></el-option>
            <el-option label="疗效系列" value="疗效系列"></el-option>
            <el-option label="其他系列" value="其他系列"></el-option>
          </el-select>
          <div class="search">
            <el-input placeholder="请输入商品名称搜索" clearable prefix-icon="el-icon-search" v-model="goodsSearchVal">
            </el-input>
            <el-button type="primary">搜索</el-button>
          </div>
        </el-header>
        <el-main class="cell-list">
          <el-checkbox-group v-model="goodsCheck">
            <el-checkbox :label="i" v-for="(item,i) in 20" :key='i'>
              <div class="card">
                <div class="card-title">
                  <div class="name-close">
                    <div class="name">菲灵魔法定型发胶</div>
                  </div>
                  <div class="size">500ml</div>
                </div>
              </div>
            </el-checkbox>

          </el-checkbox-group>
        </el-main>
        <el-footer>
          <div class="footer">
            <div class="left">共选择<b>3</b>项</div>
            <div class="btn right" @click="goodsConfirm">加入盘点</div>
          </div>
        </el-footer>
      </el-container>
    </el-drawer>
  </el-container>
</template>

<script>
  export default {
    data() {
      return {
        timePicker: new Date().getFullYear() + '-' + ((new Date().getMonth() + 1) > 9 ? new Date().getMonth() + 1 :
          '0' + (new Date().getMonth() + 1)) + '-' + (new Date().getDate() > 9 ? new Date().getDate() : '0' +
          new Date().getDate()),
        outboundType: 0,
        markInput: '', // 留言
        stepperNum: '', // 库存数量
        outboundDialogShow: false,
        outboundSearchVal: '',
        outboundName: '',
        outboundRadio: '',
        // 添加商品
        goodsDrawerShow: false,
        region: '',
        goodsSearchVal: '',
        goodsName: '',
        goodsCheck: [],
      }
    },
    computed: {},
    watch: {},

    mounted() {},
    methods: {
      // 返回上级
      returnOn() {
        this.$router.go(-1)
      },
      // 清空已选
      clearGoods() {
        this.$confirm('确定要清空已选商品?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          this.$message({
            type: 'success',
            message: '清除成功!'
          });
        }).catch(() => {
          this.$message({
            type: 'info',
            message: '已取消清除'
          });
        });
      },
      outboundConfirm() {
        this.outboundName = this.outboundRadio
        this.outboundDialogShow = false

      },
      goodsConfirm() {
        this.goodsDrawerShow = false
      },
      jumpTakingQuery() {
        this.$router.push({
          name: 'TakingQuery'
        })
      },
      handleClose() {
        this.outboundDialogShow = false
        this.goodsDrawerShow = false
      }
    }
  };

</script>
<style lang="less" scoped>
  .container {
    height: calc(100vh);
    background-color: #f9f9f9;

    // 头部
    .el-header {
      position: relative;
      z-index: 1;
      background-color: #fff;
      font-weight: bold;
      font-size: 16px;
      color: #333;
      height: 50px !important;
      line-height: 50px;
      text-align: center;
      border-bottom: 1px solid #e9e9e9;

      .left {
        position: absolute;
        left: 20px;
        top: 50%;
        transform: translateY(-50%);
        color: #46a6ff;
        font-size: 24px;
      }
    }

    .container1 {
      background-color: #fff;
      box-shadow: 0 0 2px #ccc;
      color: #666;

      .main-title {
        font-weight: bold;
        font-size: 16px;
        line-height: 50px;
        border-bottom: 1px solid #f2f2f2;
        padding: 0 15px;
        display: flex;
        justify-content: space-between;

        .title-right {
          display: flex;
          justify-content: flex-end;
          align-items: center;
          font-weight: normal;
          font-size: 12px;

          .btn {
            width: 70px;
            line-height: 30px;
            text-align: center;
            border: 1px solid #409eff;
            border-radius: 5px;
            margin-left: 10px;
          }

          .btn1 {
            color: #409eff;
          }

          .btn2 {
            background-color: #409eff;
            color: #fff;
          }
        }
      }

      .body {
        padding: 0 15px;
      }
    }

    .left-container {
      width: 50%;
      margin: 20px 10px 20px 20px;

      .body {
        .cell {
          display: flex;
          justify-content: space-between;
          align-items: center;
          line-height: 50px;
          border-bottom: 1px solid #f2f2f2;

          .right {
            display: flex;
            justify-content: flex-end;
            align-items: center;

            .item {
              border: 1px solid #f2f2f2;
              line-height: 30px;
              text-align: center;
              width: 60px;
              margin-left: 5px;
              border-radius: 30px;
              font-size: 12px;
            }

            .item1 {
              border-color: #409eff;
              color: #409eff;
              background-color: #f6faff;
            }
          }
        }

        .mark {
          margin-top: 20px;

          .mark-title {
            line-height: 40px;
          }
        }
      }
    }

    .right-container {
      width: 50%;
      margin: 20px 20px 20px 10px;

      /deep/ .el-header {
        border-bottom: 0;

        .main-title {
          border-bottom: 0;
        }


      }

      .body {
        padding-top: 10px;
      }
    }

    .card {
      padding: 15px;
      background-color: #f9f9f9;
      border: 1px solid #f2f2f2;
      border-radius: 10px;
      padding-right: 20px;
      margin-bottom: 15px;

      .card-title {
        .name-close {
          display: flex;
          justify-content: space-between;
          align-items: center;
          padding: 10px 0;

          .close {
            font-size: 18px;
            color: #999;
          }
        }

        .size {
          margin-bottom: 10px;
          color: #999;

        }
      }
    }

    .el-footer {
      width: 100%;
      background-color: #fff;
      border-top: 1px solid #f2f2f2;
      display: flex;
      justify-content: center;
      align-items: center;

      .el-button {
        width: 30%;
      }
    }

    /deep/ .el-dialog {
      min-width: 400px;

      .el-dialog__header {
        padding: 0;
        margin: 0;
      }

      .el-dialog__body {
        height: 410px;
      }

      .dialog-title {
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding: 15px;

        .center {
          font-size: 16px;
          font-weight: bold;
        }

        .el-icon-close {
          font-size: 20px;
          color: #409eff;
        }
      }

      .dialog-header.el-header {
        padding: 0 10px;
        box-sizing: content-box;
        border-bottom: none;

        .search {
          display: flex;
          justify-content: space-around;
          align-items: center;

          .el-button--primary {
            height: 40px;
            margin-left: -6px;
            z-index: 1;
            font-size: 12px;
            border-radius: 0 5px 5px 0;

          }

          .el-button--primary:focus,
          .el-button--primary:hover,
          .el-button:active,
          .el-button:focus,
          .el-button:hover {
            color: #fff;
            border-color: #409eff;
            background-color: #409eff;
          }

          /deep/ .el-input__inner {
            height: 40px;
            border: 1px solid #dcdfe6;
            border-right: 0;
            border-radius: 5px 0 0 5px;

            &:focus,
            &:hover {
              border-color: #dcdfe6;
            }
          }
        }
      }

      .cell-list {
        width: 100%;
        padding: 0 10px 10px !important;



        .el-radio-group {
          width: 100%;
          position: relative;

          .el-radio__input.is-checked+.el-radio__label {
            color: #666;
          }

          .el-radio {
            display: flex;
            justify-content: space-between;
            align-items: center;
            border-bottom: 1px solid #f2f2f2;
            margin-right: 0;

            &:last-child {
              border-bottom: none;
            }

            .dialog-title {
              display: flex;
              justify-content: flex-start;
              align-items: center;
              font-size: 12px;
              padding: 15px 0;
            }

            .el-radio__input {
              position: absolute;
              right: 10px;
              top: 50%;
              transform: translateY(-50%);
            }
          }
        }

      }

      .el-footer {
        .footer {
          display: flex;
          justify-content: space-around;
          align-items: center;
          width: 100%;


          .btn {
            width: 80%;
            text-align: center;
            border: 1px solid #409eff;
            border-radius: 50px;
            line-height: 40px;
            background-color: #409eff;
            color: #fff;
            font-weight: bold;
          }
        }
      }
    }

    /deep/ .el-drawer {
      min-width: 400px;

      .el-drawer__header {
        padding: 0;
        margin: 0;
      }

      .drawer-title {
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding: 15px;
        border-bottom: 1px solid #f2f2f2;

        .center {
          font-size: 16px;
          font-weight: bold;
        }

        .el-icon-close {
          font-size: 20px;
          color: #409eff;
        }
      }

      .el-header {
        padding: 10px 20px;
        box-sizing: content-box;
        height: auto !important;

        .el-select {
          width: 100%;
        }

        .search {
          display: flex;
          justify-content: space-around;
          align-items: center;

          .el-button--primary {
            height: 40px;
            margin-left: -6px;
            z-index: 1;
            font-size: 12px;
            border-radius: 0 5px 5px 0;

          }

          .el-button--primary:focus,
          .el-button--primary:hover,
          .el-button:active,
          .el-button:focus,
          .el-button:hover {
            color: #fff;
            border-color: #409eff;
            background-color: #409eff;
          }

          /deep/ .el-input__inner {
            height: 40px;
            border: 1px solid #dcdfe6;
            border-right: 0;
            border-radius: 5px 0 0 5px;

            &:focus,
            &:hover {
              border-color: #dcdfe6;
            }
          }
        }
      }

      .cell-list {
        width: 100%;
        padding: 10px 20px 20px !important;

        .el-checkbox-group {
          width: 100%;
          position: relative;
          font-size: 12px;

          .el-checkbox__input.is-checked+.el-checkbox__label {
            color: #666;
          }

          .el-checkbox {
            background-color: #f9f9f9;
            border: 1px solid #f2f2f2;
            border-radius: 10px;
            margin-bottom: 15px;
            width: 100%;

            .el-checkbox__input {
              position: absolute;
              right: 10px;
              top: 50%;
              transform: translateY(-50%);
            }

            .card {
              border: none;
              margin-bottom: 0;

              .card-title {

                .name-close {
                  padding-top: 0;

                  .name {
                    font-size: 14px;
                  }
                }
              }
            }


          }


        }

      }


      .el-footer {
        .footer {
          display: flex;
          justify-content: space-between;
          align-items: center;
          width: 100%;


          .btn {
            width: 40%;
            text-align: center;
            border: 1px solid #409eff;
            border-radius: 50px;
            line-height: 40px;
          }

          .left {
            color: #666;

            b {
              color: #f56c6c;
            }
          }

          .right {
            background-color: #409eff;
            color: #fff;
            font-weight: bold;
          }
        }
      }
    }
  }

  .el-main {
    padding: 0 !important;
  }

</style>
